module.exports = __webpack_public_path__ + "img/new_qr_scan.472a98fd.gif";